import React from "react";

export const EMPLOYMENT_TYPES = [
    {value: "AGRICULTURE", name: "Agriculture, Forestry, Fishing and Hunting"},
    {value: "MINING", name: "Mining, Quarrying, and Oil and Gas Extraction"},
    {value: "UTILITIES", name: "Utilities"},
    {value: "CONSTRUCTION", name: "Construction"},
    {value: "MANUFACTURING", name: "Manufacturing"},
    {value: "WHOLESALE", name: "Wholesale Trade"},
    {value: "RETAIL", name: "Retail Trade"},
    {value: "TRANSPORT", name: "Transportation and Warehousing"},
    {value: "INFORMATION", name: "Information"},
    {value: "FINANCE", name: "Finance and Insurance"},
    {value: "REAL_ESTATE", name: "Real Estate and Rental and Leasing"},
    {value: "PROFESSIONAL", name: "Professional, Scientific, and Technical Services"},
    {value: "MANAGEMENT", name: "Management of Companies and Enterprises"},
    {value: "EDUCATION", name: "Educational Services"},
    {value: "HEALTH", name: "Health Care and Social Assistance"},
    {value: "ART", name: "Arts, Entertainment, and Recreation"},
    {value: "FOOD", name: "Accommodation and Food Services"},
    {value: "PUBLIC", name: "Public Administration"},
    {value: "WASTE", name: "Administrative and Support and Waste Management and Remediation Services"},
]